import { render, staticRenderFns } from "./MasterCampaign.vue?vue&type=template&id=dc40acc0&"
import script from "./MasterCampaign.vue?vue&type=script&lang=js&"
export * from "./MasterCampaign.vue?vue&type=script&lang=js&"
import style0 from "./MasterCampaign.vue?vue&type=style&index=0&id=dc40acc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports